<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'COMPLAINT|Lokalizacja' | translate }}</h3>
        <button
            iccIconButton
            (click)="cancel()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <div class="map-dialog-content">
            <div class="map-coordinates" *ngIf="markerPosition">
                <strong>{{ 'COMPLAINT|Współrzędne:' | translate }}</strong>
                {{ markerPosition.lat.toFixed(6) }}, {{ markerPosition.lng.toFixed(6) }}
            </div>
            <google-map
                [zoom]="mapZoom"
                [center]="markerPosition!"
                [options]="{
                    fullscreenControl: true,
                    mapTypeControl: true,
                    streetViewControl: true,
                    zoomControl: true
                }"
            >
                <map-marker
                    [position]="markerPosition!"
                ></map-marker>
            </google-map>
        </div>
    </div>
</div>
